import { DialogService, GridAction } from '@eforall/dashboard';
import { AccTeamVenture } from '@interfaces';
import { AccVentureDialog } from '../../../acc-venture';
import { AccTeamDialogDataService } from '../../acc-team-dialog-data.service';

export function getActions(dialog: DialogService, dialogDataService: AccTeamDialogDataService) {

	const actions: GridAction<AccTeamVenture>[] = [
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View Venture Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialog.showCustom(AccVentureDialog, { data: { accVentureId: rows[0]!.accVentureId } }, 900, 700);
			}
		},
	];

	return actions;
}